import { ESharedComponent } from '../../../../services/UI/State/ESharedComponent';
import { GEPStateSnapshot } from './GoalEditorPanel/GEPState/GEPStateSnapshot';
import { State } from 'source/app/services/UI/State/State';

export const GetGEPState = () => State.ReadClass<GEPStateSnapshot>(ESharedComponent.GoalEditorPanel)!.state;
